<template>
  <!-- 選択 -->
  <div class="answer-multioption select">
    <ol class="answer-list" :class="question.question.class">
      <li
        v-for="(q, idx) in option"
        :key="`opt${idx}`"
        class="option"
        :class="{
          'answer-active': !sent && selected === idx,
          'answer-correct': sent && answerIndexInOrder === idx,
          'answer-incorrect': sent && selected === idx && answerIndexInOrder !== idx,
        }"
        @click="
          () => {
            if (!sent) {
              selected = idx;
            }
          }
        "
      >
        <div class="boxes">
          <img
            v-if="sent && selected === idx && answerIndexInOrder === idx"
            src="@/assets/img/maru.png"
          />
          <img
            v-else-if="sent && selected === idx && answerIndexInOrder !== idx"
            src="@/assets/img/batsu.png"
          />
          <span v-if="q">
            {{ circleNum[idx] }}
          </span>
        </div>
        <div class="options" v-if="q">{{ q }}</div>
        <div class="options" v-else>
          {{ circleNum[idx] }}
        </div>
        <div class="boxes" v-if="!q"></div>
      </li>
    </ol>
  </div>
</template>


<script>
/* eslint-disable no-console */
import CircleNum from "@/tools/circleNum";
import randomizer from "@/tools/randomizer";

export default {
  data() {
    return {
      selected: null
    };
  },
  mounted() {
    console.log(this.option);
    if (!this.optionOrder) {
      if (this.question.question.random) {
        this.$store.commit(
          "setOptionOrder",
          randomizer(this.question.question.option.map((e, idx) => idx))
        );
      } else {
        this.$store.commit(
          "setOptionOrder",
          this.question.question.option.map((e, idx) => idx)
        );
      }
    }

    if (Number.isSafeInteger(this.response) && this.sent) {
      this.selected = this.response;
    }
  },
  computed: {
    circleNum() {
      return CircleNum;
    },
    response() {
      return this.$store.getters.response;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.modal;
    },
    option() {
      return this.$store.getters.option;
    },
    optionOrder() {
      return this.$store.getters.optionOrder;
    },
    question() {
      return this.$store.getters.question;
    },
    answerIndex() {
      if (Array.isArray(this.$store.getters.answer)) {
        return this.$store.getters.answer[0];
      }
      return this.$store.getters.answer;
    },
    answer() {
      return this.question.question.option[this.answerIndex];
    },
    answerIndexInOrder() {
      return this.optionOrder.findIndex(e => e === this.answerIndex);
    },
    tof() {
      return this.optionOrder[this.selected] === this.answerIndex;
    }
  },
  watch: {
    selected(nv) {
      this.$store.commit("setResponse", {
        response: nv,
        correct: this.tof
      });
    }
  }
};
</script>

<style scoped>
.answer {
  color: #d22;
  font-size: 80%;
}

.num-box {
  display: inline-block;
  margin: 2px 0;
  width: 2em;
  background-color: #fff;
  border-radius: 10px;

  border: solid 3px #c4c4c4;
  color: #444;

  text-align: center;
}

.num-box.answer {
  font-size: 20px;
  border: solid 3px #ff4444;
  margin-right: 5px;
}

.answer-list.center li {
  text-align: center;
}

.list-btn {
  display: inline-block;
  width: calc(100% - 3em);
}

.item,
.answer-list li {
  display: flex;
}

.item div.boxes,
.answer-list li div.boxes {
  flex: 0 0 4em;
  text-align: right;
}

.item div.options,
.answer-list li div.options {
  flex: 1 0 calc(100% - 8em);
  padding: 0 0.5em;
}

@media screen and (orientation: landscape) {
  .item div.boxes,
  .answer-list li div.boxes {
    flex: 0 0 3em;
    text-align: right;
  }

  div.boxes img {
    width: 1em;
  }
}
</style>